import {FC, useEffect, useState} from 'react'
import {ID} from '@/_metronic/helpers'
import {SponsorshipIndicators, initialIndicators} from './core/_models'
import {IndicatorCard} from '@/components/cards/IndicatorCard'
import {getIndicators} from './core/_requests'

type Props = {
  sponsor: ID,
  from: Date
  to: Date
}

const Indicators: FC<Props> = ({sponsor, from, to}) => {
  const [indicators, setIndicators] = useState<SponsorshipIndicators>(initialIndicators)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    const load = async () => {
      try {
        setIsLoading(true)
        const res = await getIndicators(from, to, sponsor)

        if (res) {
          setIndicators(res)
        }
      } catch (e: any) {
        console.log(e)
      } finally {
        setIsLoading(false)
      }
    }

    load()
  }, [from, to, sponsor])

  return (
    <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
      <div className="row">
        <div className="col-xl-3">
          <IndicatorCard
            value={indicators.affiliates}
            title="Affiliates"
            icon="profile-user"
            color="success"
            isLoading={isLoading}
          />
        </div>
        <div className="col-xl-3">
          <IndicatorCard
            value={indicators.clicks}
            title="Clicks"
            icon="click"
            color="primary"
            isLoading={isLoading}
          />
        </div>

        <div className="col-xl-3">
          <IndicatorCard
            value={`${indicators.convertionRate}%`}
            title="Conversion"
            icon="chart-pie-simple"
            color="info"
            isLoading={isLoading}
          />
        </div>

        <div className="col-xl-3">
          <IndicatorCard
            value={indicators.earnings}
            title="Earnings"
            icon="enjin-coin"
            color="danger"
            isLoading={isLoading}
          />
        </div>


      </div>
    </div>
  )
}

export default Indicators
